import React from "react";
import { UserRole } from "../../../types/userTypes";
import useAuth  from "../../../hooks/useAuth";

interface RoleRenderingProps {
    children: React.ReactNode;
    roles: UserRole[];
}

const RoleRendering: React.FC<RoleRenderingProps> = ({ children, roles }) => {
    const { checkUserRoles } = useAuth();

    const hasRole = checkUserRoles(roles)

    if (!hasRole) return null;

    return <>{children}</>;
};

export default RoleRendering;